export default __webpack_public_path__ + "static/media/csi-krishna-godavari-diocese-seal.8ca9d34d.png";